<template>
  <a class="attachment-link" :title="message.AttachmentFile.Name">
          <!-- click: function(){ $parents[1].showImagePreview($data.message.AttachmentFile.Url); }, -->
          <img class="image img-fluid" :src="message.AttachmentFile.Url" :show="message.AttachmentFile.Url" />
        </a>
</template>

<script>
export default {
    name: 'imagePayload',
    data: function (){
        return {}
        message: null
    },
    created (){
        this.message = this.$parent._props.message;
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/ImagePayload.vue